import { IAccountItem, IAccountSearchItem } from '../interfaces';
import { IFiltersItem, INewArticlesItem } from '../MyAccounts/interface';
import store from '../../../store/index';

// serialize articles response to common interface IArticlesItem objects
export const serializeAccounts = (jsonData: any): IAccountItem[] => {
  let accounts: IAccountItem[] = [];

  for (let company of jsonData) {
    accounts.push({
      accountId: company['company_id'],
      accountName: company['company_name'],
      accountLogo: company['company_logo'],
      accountPulse: company['company_pulse'],
      accountPersonality: company['company_personality'],
      accountShare: company['company_share'],
      accountSubscribers: company['company_subscribers'],
      accountTicker: company['company_ticker'],
      flag: '',
      loading: false,
      state: store.getState().myAccounts.selectedAccounts.some((acc) => acc.accountId === company['company_id']) ? 'selected' : '',
    });
  }

  return accounts;
};

// serialize articles response to common interface IArticlesItem objects
export const serializeNewsArticles = (jsonData: any): INewArticlesItem[] => {
  let articles: INewArticlesItem[] = [];

  for (let article of jsonData) {
    articles.push({
      alerts: article['alerts'],
      id: article['article_id'],
      companyName: article['company_name'],
      companyId: article['company_id'],
      companyLogo: article['company_logo'],
      type: article['article_type'],
      title: article['article_title'],
      description: article['article_description'],
      image_url: article['article_image'],
      website: article['article_domain'],
      publish_date: article['article_publish_timestamp'],
      is_favourite: article['article_is_favourite'] === 'False' ? false : true,
      is_curated: article['article_is_curated'],
      imageServer: article['article_image_server'],
      videoUrl: article['videoUrl'],
      videoHtml: article['videoHtml'],
      link: article['article_link'],
    });
  }

  return articles;
};

// serialize articles response to common interface IArticlesItem objects
export const serializeNewsFilters = (jsonData: any): IFiltersItem[] => {
  let filters: IFiltersItem[] = [];

  for (let filter of jsonData) {
    filters.push({
      filterId: filter['filter_id'],
      filterName: filter['filter_name'],
      filterColor: filter['filter_color'],
      filterTypeName: filter['filter_type_name'],
      subFilterId: filter['sub_filter_id'],
      isSelected: filter['is_selected'],
    });
  }

  return filters;
};

export const parseColorGradients = (obj: any) => {
  if (obj !== undefined && obj !== null) {
    let _pulse = JSON.parse(obj);
    let coloring = '';
    if (_pulse.length === 1) {
      coloring += `${_pulse[0]?.color}`;
    } else {
      _pulse.map((p: any, i: number) => {
        if (p.start === '0%') {
          coloring += ` ${p.color} ${p.end},`;
        } else if (i === _pulse.length - 1) {
          coloring += ` ${p.color} ${p.start}, ${p.color} ${p.end}`;
        } else {
          coloring += ` ${p.color} ${p.start}, ${p.color} ${p.end},`;
        }
      });
    }
    return coloring;
  }
};
//////////////////////////////////For Persona//////////////////////////////////
export const backgroundColorParsing = (personality1: any) => {
  if (personality1 === undefined || personality1 === null) {
    // return "";
    return '#979797 360deg';
  }
  let coloring = '';
  if (personality1 !== null && personality1 !== undefined) {
    let personality = JSON.parse(personality1);
    if (personality.length) {
      if (personality.length === 1) {
        coloring += `${personality[0]?.color} 0deg,${personality[0]?.color} 360deg `;
      } else {
        personality &&
          personality?.forEach((p: any, i: any) => {
            if (p.start === '0%') {
              coloring += ` ${p.color} ${360 / (100 / parseInt(p.end)) + 'deg'},`;
            } else if (i === personality.length - 1) {
              coloring += `${p.color} ${360 / (100 / parseInt(p.end)) - 10 + 'deg'},`;
              coloring += `${personality[0]?.color}`;
            } else {
              coloring += `${p.color} ${360 / (100 / parseInt(p.end)) + 'deg'},`;
            }
            return null;
          });
      }
    }
  }
  return coloring;
};

export const searchAccountsSerialize = (jsonData: any): IAccountSearchItem[] => {
  let accounts: IAccountSearchItem[] = jsonData?.map((account: any) => ({
    companyid: account.company_id,
    name: account.company_name,
    logo: account.company_logo,
    symbol: '',
    flag: account.company_added ? 'True' : 'False',
    loading: false,
    accountPersonality: account.company_personality,
    accountPulse: account.company_pulse,
    accountSubscribers: account.company_subscribers,
    accountTicker: account.company_ticker,
    accountShare: account.company_share,
    state: store.getState().myAccounts.selectedAccounts.some((acc) => acc.accountId === account.company_id) ? 'selected' : '',
  }));
  return accounts;
};
